// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BVoK2","button":"styles_button__2GUvl","language":"styles_language__ebE2h","check":"styles_check__jv-Et"};